import { render, staticRenderFns } from "./AccountPassword.vue?vue&type=template&id=be874d0a&scoped=true"
import script from "./AccountPassword.vue?vue&type=script&lang=js"
export * from "./AccountPassword.vue?vue&type=script&lang=js"
import style0 from "./AccountPassword.vue?vue&type=style&index=0&id=be874d0a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be874d0a",
  null
  
)

export default component.exports